export default "__VITE_PUBLIC_ASSET__57530c92__"